import { Route } from '@angular/router';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { NavBarRoute } from "./core/models/users.models";
import { RedirectComponent } from "./layout/layouts/redirect/redirect.component";
import { NoAuthGuard } from "./core/auth/guards/noAuth.guard";

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [
    // Redirect empty path to '/example'
    {
        path: '',
        canMatch: [AuthGuard],
        pathMatch: 'full',
        component: RedirectComponent,
    },
    {
        path: '',
        canMatch: [NoAuthGuard],
        pathMatch: 'full',
        redirectTo: '/log-in',
    },
    // Redirect signed-in user to the '/example'
    //
    // After the user signs in, the sign-in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    { path: 'signed-in-redirect', pathMatch: 'full', redirectTo: '/' },

    // Public routes for guests
    {
        path: '',
        component: LayoutComponent,
        data: {
            layout: 'empty',
        },
        children: [
            {
                path: 'consultation',
                loadChildren: () =>
                    import('app/modules/consultation/consultation.module').then(
                        (m) => m.ConsultationModule
                    ),
            },
            {
                path: 'special_consultation',
                loadChildren: () =>
                    import('app/modules/special-consultation/special-consultation.module').then(
                        (m) => m.SpecialConsultationModule
                    ),
            },
            // {
            //     path: 'slot_booking',
            //     loadChildren: () =>
            //         import('app/modules/slot-booking/slot-booking.module').then(
            //             (m) => m.SlotBookingModule
            //         ),
            // }
        ],
    },

    // Auth routes for all
    {
        path: '',
        component: LayoutComponent,
        data: {
            layout: 'empty',
        },
        children: [
            {
                path: 'log-in',
                loadChildren: () =>
                    import('app/modules/auth/log-in/log-in.module').then(
                        (m) => m.AuthLogInModule
                    ),
            },
        ],
    },

    // Auth routes for authenticated users
    {
        path: '',
        canMatch: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty',
        },
        children: [
            {
                path: 'insufficient-access',
                loadChildren: () =>
                    import(
                        'app/modules/auth/insufficient-access/insufficient-access.module'
                    ).then((m) => m.AuthInsufficientAccessModule),
            },
            {
                path: 'sign-out',
                loadChildren: () =>
                    import('app/modules/auth/sign-out/sign-out.module').then(
                        (m) => m.AuthSignOutModule
                    ),
            },
        ],
    },

    //Feature Routes
    {
        path: '',
        canMatch: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty',
        },
        children: [
            {
                path: 'chat',
                redirectTo: NavBarRoute.care_chat,
            },
            {
                path: 'home',
                redirectTo: NavBarRoute.care_dashboard
            },
            {
                path: 'patients',
                redirectTo: NavBarRoute.care_patients
            },
            {
                path: 'tasks',
                redirectTo: NavBarRoute.care_tasks
            },
            {
                path: 'renewals',
                redirectTo: NavBarRoute.care_renewals
            },
            {
                path: 'admin_tools',
                loadChildren: () =>
                    import('app/modules/admin-tools/admin-tools.module').then(
                        (m) => m.AdminToolsModule
                    ),
            },
            {
                path: 'knowledge_base',
                redirectTo: NavBarRoute.tools_knowledge_base
            },
            {
                path: 'diet_tool',
                loadChildren: () =>
                    import('app/modules/diet-tool/diet-tool.module').then(
                        (m) => m.DietToolModule
                    ),
            },
            {
                path: 'sales_chat',
                redirectTo: NavBarRoute.sales_whatsapp_chat,
            },
            {
                path: 'template',
                redirectTo: NavBarRoute.care_diet_chart_template_management
            },
            {
                path: 'query_review',
                redirectTo: NavBarRoute.tools_query_review
            },
        ],
    },
    //Feature Routes
    {
        path: '',
        canMatch: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'navigator',
        },
        children: [
            {
                path: 'sessions',
                loadChildren: () =>
                    import('app/modules/sessions/sessions.module').then(
                        (m) => m.SessionsModule
                    ),
            },
            {
                path: 'tools',
                loadChildren: () =>
                    import('app/modules/tools/tools.module').then(
                        (m) => m.ToolsModule
                    ),
            },
            {
                path: 'care',
                loadChildren: () =>
                    import('app/modules/care/care.module').then(
                        (m) => m.CareModule
                    ),
            },
            {
                path: 'sales',
                loadChildren: () =>
                    import('app/modules/sales/sales.module').then(
                        (m) => m.SalesModule
                    ),
            },
            {
                path: 'bd',
                loadChildren: () =>
                    import('app/modules/bd/bd.module').then(
                        (m) => m.BDModule
                    ),
            }
        ],
    },
];
